"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TableElements_1 = require("./TableElements");
var useBonusConditionsData_1 = require("./useBonusConditionsData");
var useCalculateDefaultWelcomePackage_1 = require("./useCalculateDefaultWelcomePackage");
var useMainBonusData_1 = require("./useMainBonusData");
var DetailedInfo = function (_a) {
    var _b, _c, _d, _e;
    var userType = _a.userType, closeDetailedInfo = _a.closeDetailedInfo;
    var t = (0, next_intl_1.useTranslations)('translation');
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var bonusData = (0, swr_hooks_1.useCalculateWelcomePackage)(swr_hooks_1.BonusTag.POSITION_HOME_BANNER);
    var bonusDataDefault = (0, useCalculateDefaultWelcomePackage_1.useCalculateDefaultWelcomePackage)();
    var bonusDataTable = (0, useMainBonusData_1.useMainBonusData)([
        bonusData.first,
        bonusData.second,
        bonusData.third,
        bonusData.fourth,
    ]);
    var bonusConditionsTable = (0, useBonusConditionsData_1.useBonusConditionsData)([
        {
            key: 'maxBet',
            value: (_b = bonusData.currentBonus) === null || _b === void 0 ? void 0 : _b.maxBet,
            welcomeValue: (_c = bonusDataDefault.currentBonus) === null || _c === void 0 ? void 0 : _c.maxBet,
        },
        {
            key: 'wager',
            value: (_d = bonusData.currentBonus) === null || _d === void 0 ? void 0 : _d.wager,
            welcomeValue: (_e = bonusDataDefault.currentBonus) === null || _e === void 0 ? void 0 : _e.wager,
        },
        {
            key: 'maxBonusAmount',
            value: bonusData.amount,
            welcomeValue: bonusDataDefault === null || bonusDataDefault === void 0 ? void 0 : bonusDataDefault.amount,
        },
    ]);
    var onButtonClick = (0, react_1.useCallback)(function () {
        if (isAuth)
            openDeposit();
        else
            signUpNavigate();
    }, [isAuth, openDeposit, signUpNavigate]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "480px", height: "auto", padding: "0", onClose: closeDetailedInfo, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, userType === swr_hooks_1.USER_TYPES.VIP ? t('vipOffer') : t('welcomeOffer')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.secondaryTitle }, t('depositBonuses')),
            react_1.default.createElement(TableElements_1.Table, null,
                react_1.default.createElement(TableElements_1.Head, null,
                    react_1.default.createElement(TableElements_1.Row, null, bonusDataTable.columns.map(function (column, index) { return (react_1.default.createElement(TableElements_1.Cell, { key: column.field, style: {
                            width: "".concat(index === 0
                                ? '10%'
                                : index === 1
                                    ? '50%'
                                    : index === 2
                                        ? '15%'
                                        : '20%'),
                        } }, column.label)); }))),
                react_1.default.createElement(TableElements_1.Body, null, bonusDataTable.rows.map(function (row, idx) {
                    var cells = bonusDataTable.columns.map(function (column, index) { return (react_1.default.createElement(TableElements_1.Cell, { key: "".concat(column.field).concat(index).concat(idx), style: {
                            width: "".concat(index === 0
                                ? '10%'
                                : index === 1
                                    ? '50%'
                                    : index === 2
                                        ? '15%'
                                        : '20%'),
                        }, className: index === 0
                            ? styles_module_scss_1.default.cellNumber
                            : index === 1
                                ? styles_module_scss_1.default.cellBonus
                                : '' }, row[column.field])); });
                    return (react_1.default.createElement(TableElements_1.Row, { key: "".concat(row.field).concat(idx), isEven: idx % 2 !== 0 }, cells));
                }))),
            react_1.default.createElement("br", null),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.secondaryTitle }, t('offerFeatures')),
            react_1.default.createElement(TableElements_1.Table, null,
                userType === swr_hooks_1.USER_TYPES.VIP ? (react_1.default.createElement(TableElements_1.Head, null,
                    react_1.default.createElement(TableElements_1.Row, null, bonusConditionsTable.columns.map(function (column, index) { return (react_1.default.createElement(TableElements_1.Cell, { key: column.field, style: {
                            width: '33%',
                        }, className: index === 2 ? styles_module_scss_1.default.cellVipBonus : '' }, column.label)); })))) : null,
                react_1.default.createElement(TableElements_1.Body, null, bonusConditionsTable.rows.map(function (row, idx) {
                    var filteredCells = bonusConditionsTable.columns.filter(function (item) { return !(userType !== swr_hooks_1.USER_TYPES.VIP && item.field === 'vip'); });
                    var cells = filteredCells.map(function (column, index) { return (react_1.default.createElement(TableElements_1.Cell, { key: "".concat(column.field).concat(index).concat(idx), style: {
                            width: "".concat(userType !== swr_hooks_1.USER_TYPES.VIP ? '50%' : '33%'),
                        }, align: "center", className: index === 0
                            ? styles_module_scss_1.default.cellNumber
                            : index === 2
                                ? styles_module_scss_1.default.cellVipBonus
                                : '' }, row[column.field])); });
                    return (react_1.default.createElement(TableElements_1.Row, { key: "".concat(row.field).concat(idx), isEven: idx % 2 !== 0 }, cells));
                }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonContainer },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", onClick: onButtonClick, text: "upper", height: "46px", maxWidth: "320px" }, t('getBonus'))))));
};
exports.default = DetailedInfo;
